export const ADD_BORROWER = "ADD_BORROWER";
export const CHANGE_BORROWER_ID = "CHANGE_BORROWER_ID";
export const REMOVE_BORROWER = "REMOVE_BORROWER";
export const SET_TITLE = "SET_TITLE";
export const SET_FIRST_NAME = "SET_FIRST_NAME";
export const SET_MIDDLE_NAME = "SET_MIDDLE_NAME";
export const SET_LAST_NAME = "SET_LAST_NAME";
export const SET_DOB = "SET_DOB";
export const SET_BIRTH_SEX = "SET_BIRTH_SEX";
